import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';
import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  CreateWorkspaceFolderParams,
  createWorkspaceFolder,
} from '../../../api/workspaces/folders/createWorkspaceFolder';

export function useCreateWorkspaceFolder(workspaceId: string) {
  const queryClient = useQueryClient();

  return useMutation(createWorkspaceFolder, {
    onSettled: handleOnSettled(queryClient, workspaceId),
    onSuccess: (data, { workspaceId }: CreateWorkspaceFolderParams) => {
      queryClient.invalidateQueries(workspaceKeys.folders({ workspaceId }));
    },
    onError: (error) => {
      apiToaster([], QuizToastActions.CREATE_FOLDER, error);
    },
  });
}

const handleOnSettled = (queryClient: QueryClient, workspaceId: string) => () =>
  queryClient.invalidateQueries(workspaceKeys.folders({ workspaceId }));
